/**
 * Block 14 «Раскрой» — PR PartsTab-UX (2a). Чистая геометрия навигации по ячейкам
 * числовой таблицы (Длина / Ширина / Кол-во). Общая для:
 *   • экранной цифровой клавиатуры (touch, `NumericKeyboard.onNavigate`),
 *   • физической клавиатуры (desktop, `onKeyDown` стрелки, Excel-стиль),
 *   • обеих вкладок (`PartsTab` и `OffcutsTab` — идентичная структура ячеек, A.4).
 *
 * Вербатим прежней inline-логики `handleKbNavigate` (numeric-keyboard.js:129-136):
 * вниз за последнюю строку создаёт новую (`append`); вправо/вниз-вбок с последней
 * ячейки последней строки — no-op (`none`), строку НЕ создаёт.
 */

export type CellDir = 'up' | 'down' | 'left' | 'right';

/** Куда переместить фокус: в существующую ячейку / создать строку / никуда. */
export type NextCell =
  | { kind: 'cell'; row: number; col: number }
  | { kind: 'append'; col: number } // вниз за последнюю строку → новая деталь, фокус в этой колонке
  | { kind: 'none' };

/**
 * Следующая ячейка от (`row`, `col`) в направлении `dir`. `colCount` — число
 * редактируемых числовых колонок (3: длина/ширина/кол-во), `rowCount` — число строк.
 */
export function nextCell(
  row: number,
  col: number,
  dir: CellDir,
  colCount: number,
  rowCount: number,
): NextCell {
  let nextRow = row;
  let nextCol = col;
  if (dir === 'right') {
    if (col < colCount - 1) nextCol += 1;
    else {
      nextCol = 0;
      nextRow += 1;
    }
  } else if (dir === 'left') {
    if (col > 0) nextCol -= 1;
    else {
      nextCol = colCount - 1;
      nextRow -= 1;
    }
  } else if (dir === 'down') {
    nextRow += 1;
  } else {
    nextRow -= 1;
  }

  if (nextRow < 0) return { kind: 'none' };
  if (nextRow >= rowCount) {
    // Только 'down' создаёт строку; перенос вправо за последнюю ячейку — no-op.
    if (dir === 'down') return { kind: 'append', col: nextCol };
    return { kind: 'none' };
  }
  return { kind: 'cell', row: nextRow, col: nextCol };
}
